"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubbleContent = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../../..");
const IframeBubble_1 = require("./IframeBubble");
const ImageBubble_1 = require("./ImageBubble");
const TextBubble_1 = require("./TextBubble");
const VideoBubble_1 = require("./VideoBubble");
const BubbleContent = ({ message, skipAnimations, onTypingEnd, }) => {
    if (!message)
        return (react_1.default.createElement(TextBubble_1.TextBubble, { message: "", skipAnimations: skipAnimations, onTypingEnd: onTypingEnd }));
    if (typeof message === "string" || "html" in message)
        return (react_1.default.createElement(TextBubble_1.TextBubble, { message: message, skipAnimations: skipAnimations, onTypingEnd: onTypingEnd }));
    switch (message.type) {
        case __1.BubbleContentType.IFRAME:
            return react_1.default.createElement(IframeBubble_1.IframeBubble, { message: message, onTypingEnd: onTypingEnd });
        case __1.BubbleContentType.VIDEO:
            return react_1.default.createElement(VideoBubble_1.VideoBubble, { message: message, onTypingEnd: onTypingEnd });
        case __1.BubbleContentType.IMAGE:
        case __1.BubbleContentType.GIF: {
            return react_1.default.createElement(ImageBubble_1.ImageBubble, { message: message, onTypingEnd: onTypingEnd });
        }
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.BubbleContent = BubbleContent;
//# sourceMappingURL=index.js.map